<div class="order-product">
  <div class="order-product__header">
    <span class="order-product__header__title">Productos</span>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="order-product__body">
      @if (!state.isLoading() && !state.error()) {
        @if (state.orderDispatches().length > 0) {
          <div class="order-product__container">
            @for (orderDispatch of state.orderDispatches(); track orderDispatch.orderId) {
              <div class="order-product__item">
                <div class="order-product__item__header">
                  <span class="tag">{{ orderDispatch.orderId }}</span>
                </div>
                @for (dispatch2 of orderDispatch.dispatches; track dispatch2.originName; let i = $index) {
                  <mat-expansion-panel
                  [expanded]="true"
                  #panel>
                    <mat-expansion-panel-header>
                      <div class="order-product__item__info">
                        <div class="order-product__item__badges">
                          <span class="badge badge--blue">{{ dispatch2.deliveryStepLabel }}</span>
                          <span class="badge badge--darkblue" #tooltip="matTooltip" [matTooltip]="dispatch2.currentStateDescription" matTooltipPosition="below">
                            <span>{{ dispatch2.currentStateDescription }}</span>
                          </span>
                          <span class="badge badge--yellow">
                            <mat-icon>shopping_cart</mat-icon>
                            {{ dispatch2.items.length}}
                          </span>
                        </div>

                        <div class="order-product__item__details">
                          <div class="details">
                            <span class="details__label">Origen {{i + 1}}</span>
                            <span class="details__value">{{ dispatch2.originName }}</span>
                          </div>
                          <div class="details details--date">
                            <span class="details__label">F. elegida</span>
                            <span class="details__value">
                              <mat-icon [class]="utilService.getClassIconTimer(getShippingEstimate(dispatch2) , getDeliveryDate(dispatch2), dispatch2.currentState)">timer</mat-icon>
                              {{ getShippingEstimate(dispatch2) | date: 'dd/MM/yy' }}
                            </span>
                          </div>
                        </div>

                        <button mat-button class="order-product__item__button" (click)="redirectOrderGroupDetail(orderDispatch.orderId, dispatch2.dispatchNumber)">VER PEDIDO</button>
                      </div>
                    </mat-expansion-panel-header>

                    <div class="order-product__item__table">
                      <table class="product-table">
                        <tbody>
                          @for (product of dispatch2.items; track product.skuCode) {
                            <tr class="product-table__row">
                              <td
                                class="product-table__description"
                                [ngClass]="{ 'product-table__description--canceled': utilService.isCanceled(product.currentState) }">
                                {{ product.name }}
                              </td>
                              <td class="product-table__extra">
                                <div class="product-table__unit">{{ product.quantityOriginal }} {{ product.measurementUnit }}</div>
                                <div class="product-table__price">S/ {{ product.price | number:'1.2-2' }}</div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </mat-expansion-panel>
                }
              </div>
            }
          </div>
        }@else {
          <div class="order-product__message">
            <app-horus-message-general nameIcon="noDataMessageIcon" btnAction="ENTENDIDO" (action)="dialogRef.close()">
              <span style="color:#F6D44D; font-size: 14px; line-height: 25px;">No podemos ejecutar la acción</span><br>
              <span  style="font-weight: 400;">El pedido no tiene información de despacho</span>
            </app-horus-message-general>
          </div>
        }
      }@else if (state.error()) {
        <p>Error: {{ state.error() }}</p>
      } @else {
        <div class="order-product__loading">
          <app-horus-loading></app-horus-loading>
        </div>
      }
    </div>
</div>
